// extracted by mini-css-extract-plugin
module.exports = {"complianceBadge":"CareManagerOverview_complianceBadge__2h94d"};